(() => {
  const roots = document.querySelectorAll('[data-ms-gift-card]');

  roots.forEach((root) => {
    const buttons = [...root.querySelectorAll('[data-gift-variant]')];
    const input = root.querySelector('[data-gift-variant-input]');
    const price = root.querySelector('[data-gift-price]');

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        if (button.disabled) return;
        buttons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        if (input) {
          input.value = button.dataset.giftVariant;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (price) price.textContent = button.dataset.giftPrice;
        if (window.history.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', button.dataset.giftVariant);
          window.history.replaceState({}, '', url);
        }
      });
    });
  });
})();
